<template>
  <div>
    <div v-if="successMessage" class="alert alert-success">{{ successMessage }}</div>
    <div v-if="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>

    <b-card>
      <b-row>
        <div class="col-12 mt-3">
          <b-form @submit.prevent="addExpense" v-if="show">
            <div style="background-color:#617498; height:32px; border-radius:4px;">
              <h4 style="color:#dfe3ee; margin-left:5px; font-weight:bold;">
                Add Expense
              </h4>
            </div>

            <div class="row">
              <!-- Expense Title -->
               <div class="col-md-4 col-12">
                <b-form-group label="Title:" label-for="title">
                  <b-form-input id="title" type="text" :state="validateField(title)"  v-model="title" required />
                </b-form-group>
              </div>

              <div class="col-md-4 col-12">
                <b-form-group label="Expense Date:" label-for="expense_date">
                  <b-form-input id="expense_date" type="date" :state="validateField(expense_date)" v-model="expense_date" required />
                </b-form-group>
              </div>

              <!-- Expense Type -->
              <div class="col-md-4 col-12">
                <b-form-group label="Expense Type:" label-for="expense_type_id">
                  <b-form-select
                    id="expense_type_id"
                    :state="validateField(expense_type_id)"
                    v-model="expense_type_id"
                    :options="expenseTypes"
                    required
                  />
                </b-form-group>
              </div>

              <!-- Amount -->
              <div class="col-md-4 col-12">
                <b-form-group label="Amount($):" label-for="amount">
                  <b-form-input
                    id="amount"
                    type="number"
                    step="0.01"
                    :state="validateField(amount)"
                    placeholder="Enter amount"
                    v-model="amount"
                    required
                  />
                </b-form-group>
              </div>
              
              <!-- Document -->
              <!-- <div class="col-md-6 col-12">
                <b-form-group label="Document:" label-for="document">
                  <input
                    type="file"
                    id="document"
                    @change="onDocumentChange"
                   />
                </b-form-group>
              </div> -->
              <!-- Document -->
              <div class="col-md-6 col-12">
                <b-form-group
                  id="input-group-doc"
                  label="Document:"
                  label-for="document"
                  description="Upload PDF/DOCX/JPG/PNG (Max 10MB)"
                >
                  <div
                    class="border rounded p-3 text-center"
                    @drop.prevent="onDocumentDrop"
                    @dragover.prevent
                    @click="$refs.docInput.click()"
                    style="cursor: pointer; background-color: #f8f9fa;"
                  >
                    <i class="fas fa-cloud-upload-alt fa-2x text-muted"></i>
                    <p class="mb-0">Drag & Drop or Click to Upload</p>
                    <input
                      type="file"
                      accept=".pdf,.doc,.docx,.jpg,.png"
                      ref="docInput"
                      class="d-none"
                      @change="onDocumentChange"
                    />
                  </div>

                  <!-- Preview doc -->
                  <div v-if="document" class="d-flex flex-wrap mt-2">
                    <div class="m-2 text-center" style="width: 100px;">
                      <div v-if="document.type && document.type.includes('image')">
                        <img
                          :src="getImagePreview(document)"
                          class="img-thumbnail"
                          style="width: 100px; height: 100px; object-fit: cover;"
                        />
                      </div>
                      <div v-else>
                        <i class="fas fa-file-alt fa-3x text-primary"></i>
                        <p class="small text-truncate">{{ document.name }}</p>
                      </div>
                      <b-button
                        size="sm"
                        variant="danger"
                        class="mt-1"
                        @click.stop="removeDocument"
                      >
                        Remove
                      </b-button>
                    </div>
                  </div>
                </b-form-group>
              </div>

              <!-- Description -->
              <div class="col-md-12 col-12">
                <b-form-group label="Description:" label-for="description">
                  <b-form-textarea
                    id="description"
                    placeholder="Enter description" :class="{  'is-invalid': validateField(description) === false,  'is-valid': validateField(description) === true,}"
                    v-model="description"
                    rows="3"
                  />
                </b-form-group>
              </div>

            </div>

            <!-- Submit -->
            <b-button type="submit" variant="primary" class="mb-3" :disabled="isLoading">
              <span v-if="!isLoading">Submit</span>
              <b-spinner v-else small></b-spinner>
            </b-button>
          </b-form>
        </div>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormTextarea,
  BSpinner,
} from "bootstrap-vue";
import axios from "@/axios";

export default {
  data() {
    return {
      show: true,
      isLoading: false,
      successMessage: "",
      errorMessage: "",

      // Expense fields
      expense_date: "",
      expense_type_id: "",
      amount: "",
      description: "",
      document: null,
      title: "",

      expenseTypes: [], // will be loaded from API
    };
  },
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormTextarea,
    BSpinner,
  },
  created() {
    this.getExpenseTypes();
  },
  methods: {
      validateField(value, type = "text") {
            if (value === null || value === undefined || value === "") return null;

            if (type === "email") {
            const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return regex.test(value);
            }
            if (type === "number") {
            const regex = /^\+?[0-9 ]+$/; // accepts + and spaces
            return regex.test(value.toString().trim());
            }
            return value.toString().trim().length > 0;
      },
    getExpenseTypes() {
      axios
        .get("expenseTypesForExport") // endpoint to fetch list
        .then((res) => {
          this.expenseTypes = res.data.data.map((item) => ({
            value: item.id,
            text: item.name,
          }));
        })
        .catch(() => {
          this.errorMessage = "Failed to load expense types.";
        });
    },
    addExpense() {
      this.isLoading = true;
      const formData = new FormData();
      formData.append("title", this.title);
      formData.append("expense_date", this.expense_date);
      formData.append("expense_type_id", this.expense_type_id);
      formData.append("amount", this.amount);
      formData.append("description", this.description);
      if (this.document instanceof File) {
        formData.append("document", this.document);
      }

      axios
        .post("expensesStore", formData) // <-- API endpoint for adding expense
        .then(() => {
          this.$bvToast.toast("Expense added successfully!", {
            title: "Success",
            variant: "primary",
            solid: true,
            toaster: "b-toaster-top-right",
            autoHideDelay: 5000,
          });
          this.resetForm();
          this.isLoading = false;
          this.$router.push({ name: 'ListExpense' });
        })
        .catch((error) => {
          this.errorMessage =
            error.response?.data?.message || "Error adding expense.";
          this.isLoading = false;
        });
    },
onDocumentChange(event) {
    const file = event.target.files[0];
    if (file) this.document = file;
  },
  onDocumentDrop(e) {
    const file = e.dataTransfer.files[0];
    if (file) this.document = file;
  },
  removeDocument() {
    this.document = null;
  },
  getImagePreview(file) {
    return URL.createObjectURL(file);
  },
    resetForm() {
      this.expense_date = "";
      this.expense_type_id = "";
      this.amount = "";
      this.description = "";
      this.document = null;
      this.title = "";
    },
  },
};
</script>
